
import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation} from 'react-i18next';
// import { Link } from 'react-router-dom';

const Footer = () => {

    const { t } = useTranslation();

        return(
            <div>
                <div className="container-fluid" style={{borderTop: '3px solid #8d010e'}}>
                    <div className="row  m-5 justify-content-md-center" >
                
                        <div className="col-12 col-md-3 mb-2">
                            <Link to="/NousRejoindre" className="text-decoration-none text-dark">
                                <h3 className="text-bordeaux font-weight-bold">{t('Footer.1_3Gauche.Title')}</h3><br />
                                <p>{t('Footer.1_3Gauche.PrenezContact')}</p>
                            </Link>
                        </div>
            
                        <div className="col-12 col-md-3 mb-2">
                            <Link to="/NousRejoindre" className="text-decoration-none text-dark">
                                <h3 className="text-bordeaux font-weight-bold">{t('Footer.Milieu.Title')}</h3><br />
                                <p>{t('Footer.Milieu.CorpsTexte1')}</p>
                                <p>{t('Footer.Milieu.CorpsTexte2')}</p>
                            </Link>
                        </div>
                        
                        <div className="col-12 col-md-3 mb-2">
                            <Link to="/NousRejoindre" className="text-decoration-none text-dark">
                                <h3 className="text-bordeaux font-weight-bold ">{t('Footer.1_3Droite.Title')}</h3><br />
                                <p>{t('Footer.1_3Droite.CorpsTexte1')}</p>
                                <p>{t('Footer.1_3Droite.CorpsTexte2')}</p>
                            </Link>
                        </div>
        
                    </div>

                </div>	

                <div className="bg-dark text-white" style={{height: "30px"}}>
                    <div className="container">
                        <div className="row justify-content-md-center">
                            <Link to="/Cgv"><div className="col-md-3 text-center text-white text-decoration-none">CGV</div></Link>
                            <div className="col-md-3"></div>
                            <Link to="/Cookies"><div className="col-md-3 text-center text-white text-decoration-none">Cookies</div></Link>
                        </div>
                    </div>
                </div>

            </div>
        ) 
}

export default Footer